import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { Item } from "../NestedPayerResponse";
import { useSelector } from "react-redux";
import { ageCalculator } from "helpers/utils";

const PreauthProviderRequest = () => {
  return (
    <>
      <RequestDetails />
      <BeneficiaryDetails />
      <PhysicianInfo />
    </>
  );
};

export default PreauthProviderRequest;

const RequestDetails = () => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  const preauthRequest = viewPreauthorizationInfo?.provider_request;

  const items = [
    {
      id: 1,
      title: "Request Date Time",
      value: preauthRequest?.req_time,
    },
    {
      id: 2,
      title: "Request Bundle Id",
      value: preauthRequest?.bundlereq_id,
    },
    {
      id: 3,
      title: `Pre-Authorization Type`,
      value: preauthRequest?.claim_typenme,
    },
    {
      id: 4,
      title: `Preauthorization Sub Type`,
      value: preauthRequest?.preauth_subtype,
    },
    {
      id: 5,
      title: "Visit Reason",
      value: preauthRequest?.visitreasons,
    },

    {
      id: 66,
      title: "Prescription",
      value: preauthRequest?.prescription ? "Yes" : "No" || false,
    },

    {
      id: 6,
      title: "Transferal",
      value: preauthRequest?.transfer ? "Yes" : "No" || false,
    },

    {
      id: 8,
      title: "Priority",
      value: preauthRequest?.priority,
    },
  ];

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">{"Pre-Authorization"} Details</span>
        </span>
      </div>

      <Row>
        <Col xs={12}>
          <Row className="mt-1">
            {items?.map((item) => (
              <Col xs={6} md={4} xl={3} className="mb-3" key={item.id}>
                <Item title={item.title} value={item.value} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </motion.div>
  );
};

const BeneficiaryDetails = () => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  const preauthRequest = viewPreauthorizationInfo?.provider_request;
  const patientInfo = preauthRequest?.patient;
  const itemDetails = [
    {
      id: 1,
      title: "Identity Type",
      value: patientInfo?.identity_type,
    },
    {
      id: 2,
      title: "Identity No",
      value: patientInfo?.nationalid,
    },
    {
      id: 3,
      title: "Membership No",
      value: patientInfo?.memberid,
    },
    {
      id: 5,
      title: "Medical Record Number",
      value: patientInfo?.mrn,
    },
    { id: 4, title: "Policy No", value: patientInfo?.polycyno },
    { id: 6, title: "Class Name", value: patientInfo?.class },
    { id: 6, title: "Policy Holder Name", value: patientInfo?.polycyname },
    {
      id: 7,
      title: "Martial Status",
      value: patientInfo?.maritalStatus,
    },
    {
      id: 8,
      title: "Occupation",
      value: patientInfo?.occupation,
    },
    {
      id: 9,
      title: "Religion",
      value: patientInfo?.religion,
    },
  ];

  const { age } = ageCalculator(patientInfo?.birthdate);

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Beneficiary Details</span>
        </span>
      </div>

      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={4} md={1}>
              <div className="position-relative d-inline-block">
                <img
                  src="/test-img.png"
                  alt="Patient"
                  className="img-fluid rounded-circle border"
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "cover",
                    border: "3px solid #2c7be5",
                  }}
                />
              </div>
            </Col>
            <Col xs={8} md={11}>
              <div className="d-flex flex-column">
                <span className="fs-10 fw-bold">{patientInfo?.name}</span>
                <span className="fs-10 text-600 fw-bold text-capitalize">
                  {age?.years || "0"} Years - {patientInfo?.gender}
                </span>
              </div>
            </Col>
          </Row>
          <hr />
          <Row className="mt-1">
            {itemDetails?.map((item) => (
              <Col xs={6} md={4} xl={3} className="mb-3" key={item.id}>
                <Item title={item.title} value={item.value} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </motion.div>
  );
};

const PhysicianInfo = () => {
  // Get both claim and preauth data
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  const preauthRequest = viewPreauthorizationInfo?.provider_request;

  const practitioner = preauthRequest?.practitioner;

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Physician Info</span>
        </span>
      </div>

      {practitioner?.map((item) => {
        return (
          <Row className="mt-3">
            <Col xs={12} md={3}>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex category-sevie1  badge-subtle-success justify-content-center align-items-center">
                  <div className="imgpatientnew2">
                    <i className="fas fa-stethoscope" />
                  </div>
                </div>
                <div className="text-capitalize fs-10 text-success fw-bold">
                  {item?.practitioner_name || "N/A"}
                </div>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <Item
                title="Physician SCFHS"
                value={item?.practitioner_license}
              />
            </Col>
            <Col xs={12} md={3}>
              <Item title="Practice" value={item?.speciality_name} />
            </Col>
            <Col xs={12} md={3}>
              <Item title="Role" value={item?.practitioner_role} />
            </Col>
          </Row>
        );
      })}
    </motion.div>
  );
};
